export default __webpack_public_path__ + "static/media/undo-icon-active.16128f76.svg";